import { get } from "./Tools";

const obtenerAcumuladosPorPeriodo = async (periodo_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}procesar_nomina/acumulados-periodo/${periodo_id}/${anio}/${num_periodo}`);
  return response;
};

export { obtenerAcumuladosPorPeriodo };
